export default "__VITE_ASSET__B62CI1BY__"